export const NAVBAR_HEIGHT = 44
export const TABBAR_HEIGHT = 50
// 576:landscape phones,768:tablets,992:desktops,1200:large desktops
export const RESPONSIVE_MIN_WIDTH = 768
export const UNI_STORAGE_LOCALE = 'UNI_LOCALE'
export const ON_THEME_CHANGE = 'onThemeChange'
